// import { setToken } from "../../defaultsetting/utils/requests";
import * as authActions from "./AuthActionType";
import jwt_decode from "jwt-decode";

export default (state, action) => {
  switch (action.type) {
    case authActions.LOGIN_ATTEMPT:
      return {
        ...state,
        isLoading: true,
      };
    case authActions.FRONTEND_LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        userId: action.payload.userId,
      };

    case authActions.FRONTEND_REGISTER:
      return {
        ...state,
        isLoading: false,
        registerSuccess: [...action.payload],
      };
    case authActions.LOGIN_ERROR:
      return {
        ...state,
        // errorMessages: [...action.payload],
        isAuthenticated: false,
        isLoading: false,
      };
    case authActions.FRONTEND_LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        userId: "",
        userDetails: {},
      };
    case authActions.SET_AUTH_USER:
      return {
        ...state,
        isAuthenticated: true,
        userId: action.payload.userId,
      };
    case authActions.SET_USER_DETAILS:
      return {
        ...state,
        isAuthenticated: true,
        userDetails: { ...action.payload.userDetails },
        userType: action.payload.userType,
      };
    case authActions.CLEAR_ERRORS:
      return {
        ...state,
        errorMessages: [],
        registerSuccess: [],
      };

    default:
      return state;
  }
};
